import { computed } from "@ember/object";
import { classNames } from "@ember-decorators/component";
import ComboBoxComponent from "select-kit/components/combo-box";
import { pluginApiIdentifiers, selectKitOptions } from "select-kit/components/select-kit";
import FlairRow from "./flair-row";
import SelectedFlair from "./selected-flair";
const FlairChooser = dt7948.c(class FlairChooser extends ComboBoxComponent {
  modifyComponentForRow() {
    return FlairRow;
  }
  get selectedContent() {
    const content = (this.content || []).find(value => value[this.selectKit.valueProperty] === this.value);
    if (content) {
      return this.selectKit.modifySelection(content);
    } else {
      return this.selectKit.noneItem;
    }
  }
  static {
    dt7948.n(this.prototype, "selectedContent", [computed("value", "content.[]", "selectKit.noneItem")]);
  }
}, [pluginApiIdentifiers(["flair-chooser"]), selectKitOptions({
  selectedNameComponent: SelectedFlair
}), classNames("flair-chooser")]);
export default FlairChooser;